function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import Base from './base';
import { format } from 'date-fns';
import { capitalize } from '../util';
import activityFactory from '../activity_factory.js';
import URI from 'urijs';

var Response = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Response, _Base);

  function Response() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Response.prototype;

  _proto.initialize = function initialize() {
    return _Base.prototype.initialize.apply(this, arguments);
  };

  _proto.urlRoot = function urlRoot() {
    return URI('/api/participants').segment(this.id.toString()).segment('responses').toString();
  };

  _proto.submissionDate = function submissionDate() {
    return format(new Date(this.get('created_at')), 'MM/dd/yyyy');
  };

  _proto.submissionTime = function submissionTime() {
    return format(new Date(this.get('created_at')), 'h:mm:ssa');
  };

  _proto.poll = function poll() {
    return this.get('poll');
  };

  _proto.pollTitle = function pollTitle() {
    return this.poll().get('title');
  };

  _proto.pollLink = function pollLink() {
    return this.poll()._urlBase();
  };

  _proto.pollOwnerName = function pollOwnerName() {
    var ownerName = this.poll().get('owner_name');
    return ownerName.split(' ').map(function (item) {
      return capitalize(item);
    }).join(' ');
  };

  _proto.pollOwnerEmail = function pollOwnerEmail() {
    return this.poll().get('owner_email');
  };

  _proto.response = function response() {
    return this.get('humanized_value');
  };

  _proto.parse = function parse(attrs) {
    /*
     * TODO come up with a convention for
     * parsing out associations from our api
     */
    attrs.poll = activityFactory(attrs.poll);
    return _Base.prototype.parse.apply(this, arguments);
  };

  return Response;
}(Base);

export { Response as default };